export default __webpack_public_path__ + "static/media/slider3.6395a48d.png";